import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Services from './pages/Services';
import Realisations from './pages/Realisations';
import Contact from './pages/Contact';
import MentionsLegales from './pages/legal/MentionsLegales';
import PolitiqueConfidentialite from './pages/legal/PolitiqueConfidentialite';
import ConditionsGenerales from './pages/legal/ConditionsGenerales';
import AuditEnergetique from './pages/AuditEnergetique';
import DiagnosticValence from './pages/blog/DiagnosticValence';
import DiagnosticArdeche from './pages/blog/DiagnosticArdeche';
import DiagnosticOrange from './pages/blog/DiagnosticOrange';
import DiagnosticAvignon from './pages/blog/DiagnosticAvignon';

function App() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const id = location.hash.substring(1);
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden w-full relative">
      <Navbar />
      <main className="flex-grow overflow-x-hidden w-full relative">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/audit-energetique" element={<AuditEnergetique />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/conditions-generales" element={<ConditionsGenerales />} />
            <Route path="/diagnostic-valence-drome" element={<DiagnosticValence />} />
            <Route path="/diagnostic-ardeche-saint-peray" element={<DiagnosticArdeche />} />
            <Route path="/diagnostic-orange-vaucluse" element={<DiagnosticOrange />} />
            <Route path="/diagnostic-avignon-region" element={<DiagnosticAvignon />} />
          </Routes>
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  );
}

export default App;